module.exports = "/_next/static/images/2b58c46cbd0db43f7e602eaf1d7e1a64-pse-payment-desktop-lg.jpg.webp";